import React from 'react';
import fr from 'facet-rest';
import useMobileLayout from 'Hooks/useMobileLayout';
import { pickFunction } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import RightColumn from './RightColumn';

const RightColumnPicker = () => {
  const { pageContentResource } = usePageContentContext();
  const isMobile = useMobileLayout();

  if (isMobile) {
    return null;
  }

  return pickFunction(pageContentResource, {
    [fr.relationships.facetPlanCommentThreads.name]: () => {
      return (
        <RightColumn />
      );
    },
    [fr.relationships.default.name]: () => null,
  });
};

export default RightColumnPicker;
